














import { Component, Prop, Vue } from "vue-property-decorator";
import { ImagePreview, Popup, Swipe, SwipeItem, Loading } from "vant";
Vue.use(ImagePreview);
@Component({
  components: {
    "van-popup": Popup,
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "van-loading": Loading
  }
})
export default class ImageView extends Vue {
  @Prop()
  appId!: string | number;
  @Prop()
  ImgSrcArr!: any;

  Imgindex: number = 0;

  viewIndex: number = 0;
  showPre = false;
  showBtn = false;
  showLoad = false;

  IndexArr: Array<Number> = [];
  onChange(index: number) {
    this.viewIndex = index;
    console.log(this.IndexArr.indexOf(index));
    if (this.IndexArr.indexOf(index) < 0) {
      this.showBtn = true;
    } else {
      this.showBtn = false;
    }
  }
  onClose() {
    this.showBtn = false;
    this.showLoad = false;
  }
  openView(index: number) {
    this.Imgindex = index;
    this.showPre = true;
    this.showBtn = true;

    this.viewIndex = this.Imgindex;
  }

  // 查看原图
  viewPic() {
    this.showLoad = true;
    const elements: Array<HTMLElement> = Array.prototype.slice.call(
      document.querySelectorAll(".van-swipe-item .van-image") as NodeListOf<
        HTMLElement
      >,
      0
    );
    const src = elements[this.viewIndex].getElementsByTagName("img")[0];
    src.getAttribute("src") as string;
    const newSrc = (src.getAttribute("src") as string).split("?")[0];
    console.log(newSrc);
    src.setAttribute("src", newSrc);
    this.showBtn = false;

    this.IndexArr.push(this.viewIndex);
    src.onload = () => {
      this.showLoad = false;
    };
  }
}
